import React from 'react'
import styled from 'styled-components'

const FORM = props => <form {...props} />
export default styled(FORM)``
